import { ReactElement } from "react";
import {
  IContentAreaProps,
  IDataContext, IIndicator,
  IMenuButton,
  ISelectedNode,
  IViewController,
  SchemaNodeType
} from "../../types";
import AccessAlarmIcon from "@mui/icons-material/AccessAlarm";
import DashboardIcon from "@mui/icons-material/Dashboard";

import InterruptionPage from "./interruptionPage";
import DelayPage from "../mill/delays/delayPage";

class Module implements IViewController {

  private delaysButton: IMenuButton = {
    title: "Delays",
    icon: <AccessAlarmIcon/>,
    color: "orange",
    dataContext: {
      title: "Delays",
      module: "interruptions",
      subModule: "delays"
    }
  };

  private delaysDashboardButton: IMenuButton = {
    title: "Dashboard",
    icon: <DashboardIcon/>,
    color: "cyan",
    disabled: false,
    dataContext: {
      title: "Dashboard",
      module: "interruptions",
      subModule: "interruptionDashboard"
    }
  };


  private delaysGroupButton: IMenuButton = {
    title: "Delays",
    icon: <AccessAlarmIcon/>,
    color: "orange",
    children: [this.delaysButton],
    dataContext: {
      title: "Delays",
      module: "interruptions",
      subModule: "delaysGroup"
    }
  };

  private buttons = [this.delaysGroupButton, this.delaysButton, this.delaysDashboardButton];

  getModuleName(): string{
    return "interruptions";
  }

  getView (dataContext: IDataContext, props: IContentAreaProps): ReactElement {
    return dataContext.flag === "QMOS"
        ? <DelayPage parentSize={props.parentSize}/>
        : <InterruptionPage parentSize={props.parentSize}/>;
  }

  getButtons(node: ISelectedNode): IMenuButton[] {
    return node.type === SchemaNodeType.Zone ? [this.delaysGroupButton] : [];
  }

  getButton(subModule: string): IMenuButton | undefined {
    return this.buttons.find(x => x.dataContext && x.dataContext.subModule === subModule);
  }

  getIndicator(dataContext: IIndicator): ReactElement | undefined {
    if (dataContext.component === "") {
      return <div />;
    }

    return undefined;
  }
}

const instance = new Module();

export default instance;
